<template>

  <TemplateBasic 
    v-bind:breadcrumb="breadcrumb" 
    v-bind:permission="permission"
    v-bind:card="false">

    <div class="row">

      <div class="col-xl-4">

        <div class="ibox ">
          <div class="ibox-title">
            <h5>About</h5>
          </div>
          <div>
            <div class="ibox-content no-padding border-left-right">
              <img alt="image" class="img-fluid" src="/static/image/parkbills_bg.jpg" style="width: 100%;">
            </div>
            <div class="ibox-content profile-content">
              <!-- <h4><strong>{{ username }} </strong></h4> -->
              <h4>{{ username }}</h4>
            </div>
          </div>
        </div>

        <div class="ibox ">
          <div class="ibox-title">
            <h5>Security</h5>
          </div>

          <div>
            <div class="ibox-content profile-content">

              <div class="form-group row">
                <label class="col-lg-5 col-xl-4 col-form-label">Current Password</label>
                <div class="col ">
                  <input type="password" v-model="oldPassword" class="form-control"/>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-lg-5 col-xl-4">New Password</label>
                <div class="col ">
                  <input type="password" v-model="newPassword" class="form-control"/>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-lg-5 col-xl-4">Confirm Password</label>
                <div class="col ">
                  <input type="password" v-model="confirmNewPassword" class="form-control"/>
                </div>
              </div>

              <TemplateFeedback ref="passwordFeedback" />

              <form>
                <input type="text" v-model="username" style="display:none"/>
                <input type="password" v-model="newPassword" style="display:none"/>

                <div class="user-button">
                  <div class="row">
                    <div class="col">
                      <button v-on:click="onChangePasswordSubmit" type="button" class="btn btn-primary btn-sm btn-block"><i class="fa fa-key"></i> Submit </button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>

      </div>

      <div class="col-xl-8">
        <div class="ibox ">
          <div class="ibox-title">
            <h5>Activites</h5>
            <div class="ibox-tools">
              <a class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </a>
              <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                <i class="fa fa-wrench"></i>
              </a>
              <ul class="dropdown-menu dropdown-user">
                <li><a href="#" class="dropdown-item">Config option 1</a>
                </li>
                <li><a href="#" class="dropdown-item">Config option 2</a>
                </li>
              </ul>
              <a class="close-link">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
          <div class="ibox-content">

            <!--
            <div>
              <div class="feed-activity-list">

                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/a1.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right text-navy">1m ago</small>
                    <strong>Sandra Momot</strong> started following <strong>Monica Smith</strong>. <br>
                    <small class="text-muted">Today 4:21 pm - 12.06.2014</small>
                    <div class="actions">
                      <a href="" class="btn btn-xs btn-white"><i class="fa fa-thumbs-up"></i> Like </a>
                      <a href="" class="btn btn-xs btn-danger"><i class="fa fa-heart"></i> Love</a>
                    </div>
                  </div>
                </div>

                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/profile.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right">5m ago</small>
                    <strong>Monica Smith</strong> posted a new blog. <br>
                    <small class="text-muted">Today 5:60 pm - 12.06.2014</small>

                  </div>
                </div>

                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/a2.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right">2h ago</small>
                    <strong>Mark Johnson</strong> posted message on <strong>Monica Smith</strong> site. <br>
                    <small class="text-muted">Today 2:10 pm - 12.06.2014</small>
                    <div class="well">
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                      industry's standard dummy text ever since the 1500s.
                      Over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
                    </div>
                    <div class="float-right">
                      <a href="" class="btn btn-xs btn-white"><i class="fa fa-thumbs-up"></i> Like </a>
                      <a href="" class="btn btn-xs btn-white"><i class="fa fa-heart"></i> Love</a>
                      <a href="" class="btn btn-xs btn-primary"><i class="fa fa-pencil"></i> Message</a>
                    </div>
                  </div>
                </div>
                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/a3.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right">2h ago</small>
                    <strong>Janet Rosowski</strong> add 1 photo on <strong>Monica Smith</strong>. <br>
                    <small class="text-muted">2 days ago at 8:30am</small>
                    <div class="photos">
                      <a target="_blank" href="http://24.media.tumblr.com/20a9c501846f50c1271210639987000f/tumblr_n4vje69pJm1st5lhmo1_1280.jpg">
                        <img alt="image" class="feed-photo" src="/static/img/p1.jpg"></a>
                      <a target="_blank" href="http://37.media.tumblr.com/9afe602b3e624aff6681b0b51f5a062b/tumblr_n4ef69szs71st5lhmo1_1280.jpg">
                        <img alt="image" class="feed-photo" src="/static/img/p3.jpg"></a>
                    </div>
                  </div>
                </div>
                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/a4.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right text-navy">5h ago</small>
                    <strong>Chris Johnatan Overtunk</strong> started following <strong>Monica Smith</strong>. <br>
                    <small class="text-muted">Yesterday 1:21 pm - 11.06.2014</small>
                    <div class="actions">
                      <a href="" class="btn btn-xs btn-white"><i class="fa fa-thumbs-up"></i> Like </a>
                      <a href="" class="btn btn-xs btn-white"><i class="fa fa-heart"></i> Love</a>
                    </div>
                  </div>
                </div>
                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/a5.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right">2h ago</small>
                    <strong>Kim Smith</strong> posted message on <strong>Monica Smith</strong> site. <br>
                    <small class="text-muted">Yesterday 5:20 pm - 12.06.2014</small>
                    <div class="well">
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                      industry's standard dummy text ever since the 1500s.
                      Over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
                    </div>
                    <div class="float-right">
                      <a href="" class="btn btn-xs btn-white"><i class="fa fa-thumbs-up"></i> Like </a>
                    </div>
                  </div>
                </div>
                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/profile.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right">23h ago</small>
                    <strong>Monica Smith</strong> love <strong>Kim Smith</strong>. <br>
                    <small class="text-muted">2 days ago at 2:30 am - 11.06.2014</small>
                  </div>
                </div>
                <div class="feed-element">
                  <a href="#" class="float-left">
                    <img alt="image" class="rounded-circle" src="/static/img/a7.jpg">
                  </a>
                  <div class="media-body ">
                    <small class="float-right">46h ago</small>
                    <strong>Mike Loreipsum</strong> started following <strong>Monica Smith</strong>. <br>
                    <small class="text-muted">3 days ago at 7:58 pm - 10.06.2014</small>
                  </div>
                </div>
              </div>

              <button class="btn btn-primary btn-block m"><i class="fa fa-arrow-down"></i> Show More</button>

            </div>
            -->

          </div>
        </div>

      </div>

    </div>

  </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'title',
    text: 'Role',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="${helper.WEB_URL}/internalRoleForm?roleID=${dataItem.id}">${dataItem.title}</a>`;
    },
  },
];


export default {
  name: "PageAccount",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      helper: helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Account' },
      ],

      PARAM,
      username: '',

      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.username = JSON.parse(localStorage.getItem('user')).username;
  },
  methods: {
    onChangePasswordSubmit() {
      if(!this.oldPassword) {
        this.$refs['passwordFeedback'].setFeedbackError('Old password cannnot be empty');
        return;
      } 
      
      if(!this.newPassword) {
        this.$refs['passwordFeedback'].setFeedbackError('New password cannnot be empty');
        return;
      }

      if(!this.confirmNewPassword) {
        this.$refs['passwordFeedback'].setFeedbackError('Confirm new password cannnot be empty');
        return;
      }

      if(this.newPassword !== this.confirmNewPassword) {
        this.$refs['passwordFeedback'].setFeedbackError('Confirm new password not match');
        return;
      }

      this.$refs['passwordFeedback'].setFeedbackLoading('Changing password');
      this.$http
        .post(
          helper.API_URL + '/api2/auth2/web/reset',
          querystring.stringify({
            email: JSON.parse(localStorage.getItem('user')).username,
            password: this.oldPassword,
            newpassword: this.newPassword,
          }),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['passwordFeedback'].setFeedbackMessage('Successfully changed password. Please login again.');
          helper.redirect(helper.WEB_URL + '/logout', 3000);
        })
        .catch((error) => {
          this.$refs['passwordFeedback'].setFeedbackMessage(helper.parseAxiosErrorMessage(this, error, 'changing', 'password'));
        });
    },
  },
};
</script>
9


// WEBPACK FOOTER //
// src/components/Page/User/PageAccount.vue